import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { hideSpotifyReconnect } from "../../store/popupSlice";
import { ReConnectSpotifyPopup } from "./reConnect-popup";
import { ROUTES } from "../consts/routes.consts";

const GlobalSpotifyReconnectHandler = () => {
  const dispatch = useDispatch();
  const isModalOpen = useSelector((state: any) => state.popup.spotifyReconnect);
  const location = useLocation();

  // Don't show Spotify reconnect popup on public Meta Ads pages
  const publicMetaAdsPages = [
    "/meta-campaigns",
    "/create-meta-ads",
    "/campaigns-list",
    "/meta-ads-login",
    "/meta-ads/terms-and-conditions",
  ];
  const isPublicMetaAdsPage = publicMetaAdsPages.includes(location.pathname);

  if (isPublicMetaAdsPage) {
    return null;
  }

  // Don't show reconnect popup on visit-public-page (public playlist submission page)
  const isVisitPublicPage = location.pathname.includes("/submit-public-page/");

  // Also check for curator public page
  const isCuratorPublicPage = location.pathname.includes("/cur/");

  // Prevent popup from showing on public pages
  if (isVisitPublicPage || isCuratorPublicPage) {
    return null;
  }

  return (
    <ReConnectSpotifyPopup
      isModalOpen={isModalOpen}
      setIsModalOpen={() => dispatch(hideSpotifyReconnect())}
    />
  );
};

export default GlobalSpotifyReconnectHandler;
